import { CaretSortIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router';

import {
  AuroraText,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabelClamp,
  DropdownMenuTrigger,
  PersonalizationPlatformIcon,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@app-evolution-cms/element-ui';

import { config } from '../../config';
import { THEME, useTheme } from '../../theme-provider';

const EP_CLIENT_APP = config().EP_CLIENT_APP;

export function NavHeader() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton id="PER-navigation-sidebarHeader-nickCMS" size="lg">
              <Nick />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56"
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabelClamp className="w-full" text="Sistemas gestionados" />
            <Link
              id="PER-navigation-sidebarHeader-aeLink"
              rel="noopener noreferrer"
              target="_blank"
              to={EP_CLIENT_APP}
            >
              <DropdownMenuItem>App GBM</DropdownMenuItem>
            </Link>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}

function Nick() {
  const { theme } = useTheme();

  return (
    <div className="flex w-full items-center gap-4">
      <PersonalizationPlatformIcon className="size-8" />
      <div className="grid max-w-52 flex-1 text-left leading-tight">
        <span className="truncate text-sm font-medium">Plataforma de Personalización</span>
        <AuroraText
          colors={
            theme === THEME.DARK
              ? ['#73FF8F', '#ffffff', '#E4FFD4']
              : ['#17FF25', '#689C00', '#038F08']
          }
          className="text-[12px] tracking-wide"
        >
          Contenido & Labs
        </AuroraText>
      </div>
      <CaretSortIcon className="ml-auto size-4" />
    </div>
  );
}
